/**
 * Standardized notification type constants and configurations
 */

export const NOTIFICATION_TYPES = {
  KUDOS: "kudos",
  NUDGE: "nudge",
  BUDDIES: "buddies",
  STREAK: "streak",
  CHAT: "chat",
} as const;

export type NotificationType =
  (typeof NOTIFICATION_TYPES)[keyof typeof NOTIFICATION_TYPES];

export interface NotificationConfig {
  message: (username?: string | null, msg?: string | null) => string;
  variant: string;
  autoNavigate?: (uid?: string) => string;
  skipToast?: boolean;
}

// TODO make these classes
export const NOTIFICATION_CONFIGS: Record<
  NotificationType,
  NotificationConfig
> = {
  [NOTIFICATION_TYPES.KUDOS]: {
    message: (username, msg) =>
      `Kudos from ${username || "a fellow tugger"}${msg ? `: ${msg}` : "!"}`,
    variant: "streak",
  },
  [NOTIFICATION_TYPES.NUDGE]: {
    message: (username, msg) =>
      `${username || "A fellow tugger"} is rooting for you${
        msg ? `: ${msg}` : "!"
      }`,
    variant: "kudos",
  },
  [NOTIFICATION_TYPES.BUDDIES]: {
    message: (username, msg) =>
      msg || `Check on ${username || "a fellow tugger"}`,
    variant: "info",
    autoNavigate: (uid) => `progress?uid=${uid}`,
  },
  [NOTIFICATION_TYPES.STREAK]: {
    message: () => "Phew! Close call - let's get down to business!",
    variant: "success",
    autoNavigate: () => "tug",
  },
  [NOTIFICATION_TYPES.CHAT]: {
    message: (username, msg) =>
      msg || `New message from ${username || "a user"}`,
    variant: "info",
    autoNavigate: (uid) => `chats?uid=${uid}`,
    skipToast: true, // Don't show toast when navigating directly to chat
  },
};

export const NOTIFICATION_VARIANTS = {
  KUDOS: "kudos",
  STREAK: "streak",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
} as const;

export type NotificationVariant =
  (typeof NOTIFICATION_VARIANTS)[keyof typeof NOTIFICATION_VARIANTS];
